import React from "react"
import {useTranslation} from "react-i18next"
import {IonAccordion, IonItem, IonLabel, IonNote} from "@ionic/react"

import {Account} from "@customTypes/Account"
import User      from "@customTypes/User";

interface componentProps {
    formData:          User
    account:           Account | undefined
    setFormData:       React.Dispatch<React.SetStateAction<User>>
    updateFormHandler: any
}

export const AccordionAccount: React.FC<componentProps> = ({
    formData, account, setFormData, updateFormHandler
}) => {

    const { t } = useTranslation()

    return (
        <IonAccordion toggleIconSlot="start" value="account">
            <IonItem className="bc-accordion" slot="header">
                <IonLabel>{t('accounts.title_item')}</IonLabel>
            </IonItem>
            <IonItem slot="content">
                <IonLabel>{t('accounts.title_item')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{account ? account.name : '?'}</IonNote>
            </IonItem>
        </IonAccordion>
    )

}

export default AccordionAccount